/**
 * The Vision Board section's own vocabulary, mapped onto the panel-wide design
 * tokens in component/common/designSystem/theme.js — the same split
 * moodTheme.js, selfAssessmentTheme.js and homeTestingTheme.js use: only domain
 * meaning lives here, palettes belong to the design system.
 */
import { CHART_COLORS } from '../../../../component/common/designSystem';

/**
 * How much is actually on a board, sparse to full. A sequential ramp rather
 * than a traffic light: a two-item board is not a failure, it is a board with
 * two things on it, and the only genuinely bad case — nothing at all — is not
 * in this distribution. It has its own card.
 */
export const BOARD_SIZE_RAMP = [
  CHART_COLORS.brandSoft,
  CHART_COLORS.blue,
  CHART_COLORS.brand,
  CHART_COLORS.moss
];

/** How many boards one person keeps — sparse to prolific. */
export const VOLUME_RAMP = [
  CHART_COLORS.gray,
  CHART_COLORS.brandSoft,
  CHART_COLORS.brand,
  CHART_COLORS.green
];

/**
 * When people ask to be reminded. Follows the clock rather than any judgement:
 * warm through the day, cool at night.
 */
export const REMINDER_RAMP = [
  CHART_COLORS.amber,
  CHART_COLORS.orange,
  CHART_COLORS.brand,
  CHART_COLORS.moss
];

/** Words versus photos. Two ways of saying the same thing, so two hues. */
export const ITEM_RAMP = [CHART_COLORS.brand, CHART_COLORS.pink];

/**
 * Empty → filled in. The only place on this page where a colour carries a
 * verdict, because an untouched board really is the thing to fix.
 */
export const FILL_RAMP = [CHART_COLORS.gray, CHART_COLORS.green];
